import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';

import { type ManufacturerFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<ManufacturerFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Manufacturer (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />
      <FormField
        control={form.control}
        name="manufacturer_number"
        render={({ field }) => (
          <FormInput
            disabled={!isEditable}
            formItemClassName="col-span-12 sm:col-span-6"
            label="Manufacturer No"
            {...field}
          />
        )}
      />
    </>
  );
}
